<div>
    <h5 *ngIf="HeaderLabel">
        {{HeaderLabel}}
    </h5>
    <div [formGroup]="CustomFormGroup">
        <p-listbox [formControlName]="PropertyName" [options]="Options" [checkbox]="true" [multiple]="true" [showToggleAll]="false"
                   optionLabel="Value" optionValue="Id" (onChange)="onChange($event)"></p-listbox>
    </div>
</div>